import { lazy, type ComponentType } from 'react';

/**
 * A card of an area, loaded when its area is opened: the settings are many and heavy (the mail
 * editor brings ProseMirror), and the start of the app needs none of them - only their names.
 */
const card = (load: () => Promise<ComponentType>) => lazy(async () => ({ default: await load() }));

export const ApiClientsCard = card(() =>
  import('./firm/api-clients-card').then((m) => m.ApiClientsCard),
);
export const AppearanceCard = card(() =>
  import('./firm/appearance-card').then((m) => m.AppearanceCard),
);
export const AuditCard = card(() => import('./firm/audit-card').then((m) => m.AuditCard));
export const BillingCard = card(() => import('./firm/billing-card').then((m) => m.BillingCard));
export const CatalogCard = card(() => import('./firm/catalog-card').then((m) => m.CatalogCard));
export const BillingDetailsCard = card(() =>
  import('./firm/billing-details-card').then((m) => m.BillingDetailsCard),
);
export const DisclosureCard = card(() =>
  import('./firm/disclosure-card').then((m) => m.DisclosureCard),
);
export const DomainsCard = card(() => import('./firm/domains-card').then((m) => m.DomainsCard));
export const ErasureCard = card(() => import('./firm/erasure-card').then((m) => m.ErasureCard));
export const ExportCard = card(() => import('./firm/export-card').then((m) => m.ExportCard));
export const FactsCard = card(() => import('./firm/facts-card').then((m) => m.FactsCard));
export const FirmDetailsCard = card(() =>
  import('./firm/firm-details-card').then((m) => m.FirmDetailsCard),
);
export const FirmLogoCard = card(() => import('./firm/firm-logo-card').then((m) => m.FirmLogoCard));
export const InquiryRetentionCard = card(() =>
  import('./firm/inquiry-retention-card').then((m) => m.InquiryRetentionCard),
);
export const MandateResumptionCard = card(() =>
  import('./firm/mandate-resumption-card').then((m) => m.MandateResumptionCard),
);
export const TargetProfileCard = card(() =>
  import('./firm/target-profile-card').then((m) => m.TargetProfileCard),
);
export const IntakeAutomationCard = card(() =>
  import('./firm/intake-automation-card').then((m) => m.IntakeAutomationCard),
);
export const LegalDocuments = card(() =>
  import('./firm/legal-documents').then((m) => m.LegalDocuments),
);
export const LocationsCard = card(() =>
  import('./firm/locations-card').then((m) => m.LocationsCard),
);
export const MailSettings = card(() => import('./firm/mail-settings').then((m) => m.MailSettings));
export const MembersCard = card(() => import('./firm/members-card').then((m) => m.MembersCard));
export const PartnerAppsCard = card(() =>
  import('./firm/partner-apps-card').then((m) => m.PartnerAppsCard),
);
export const PortalLegalCard = card(() =>
  import('./firm/portal-legal-card').then((m) => m.PortalLegalCard),
);
export const ProfessionalsCard = card(() =>
  import('./firm/professionals-card').then((m) => m.ProfessionalsCard),
);
export const ReminderRules = card(() =>
  import('./firm/reminder-rules').then((m) => m.ReminderRules),
);
export const SandboxCard = card(() => import('./firm/sandbox-card').then((m) => m.SandboxCard));
export const TeamsCard = card(() => import('./firm/teams-card').then((m) => m.TeamsCard));
export const WebhooksCard = card(() => import('./firm/webhooks-card').then((m) => m.WebhooksCard));
export const DocumentDesignCard = card(() =>
  import('./firm/document-design-card').then((m) => m.DocumentDesignCard),
);
